import { createAsyncThunk } from "@reduxjs/toolkit";
import asyncInstance from "config/AsyncInstance";
import apiInstance from "config/axiosInstance";

export const GetAllGeneralDashboard = createAsyncThunk(
  "dashboard/GetAllGeneralDashboard",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("dashboard", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
